import {
  CORE_LOAD_ORDERS_EVENT_REQUEST,
  CORE_LOAD_ORDERS_EVENT_SUCCESS

} from '../../types'

const initialState = []

export default {
  ordersRoom: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ORDERS_EVENT_REQUEST:
        return []
      case CORE_LOAD_ORDERS_EVENT_SUCCESS:
        if (action.payload)
          return action.payload
        else return []
      default:
        return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/features/order/reducer.js